import { FC, ReactElement } from 'react'
import { Box } from '@mui/system'
import { Loader } from 'components'
import { Navigate, useLocation } from 'react-router'
import { useCurrentUserQuery } from 'types'
import { getRegistrationGateRedirect } from './getRegistrationGateRedirect'

interface IOnboardingRoute {
  children: ReactElement<any, any>
}

// Auth check for /welcome screens: no feature grants required (a pending coach has
// none). The registration gate still applies so the coach lands on the screen that
// matches their status (e.g. after submitting, the currentUser refetch flips them to
// pending_approval and they move to the pending-approval screen); the
// `redirectTo !== pathname` guard keeps each screen from redirecting onto itself.
export const OnboardingRoute: FC<IOnboardingRoute> = ({ children }) => {
  const { data: { currentUser } = {}, loading } = useCurrentUserQuery()
  const location = useLocation()

  if (loading) {
    return (
      <Box sx={{ height: '100vh' }}>
        <Loader />
      </Box>
    )
  }

  if (!currentUser) {
    return <Navigate to="/login" replace />
  }

  const redirectTo = getRegistrationGateRedirect({
    registrationStatus: currentUser.coachProfile?.registrationStatus
  })

  if (redirectTo && redirectTo !== location.pathname) {
    return <Navigate to={redirectTo} replace />
  }

  return children
}
